export class ContactRegisterDTO {
	// TODO ask if I need to provide all fields
	public accept_conditions: boolean;
	public subscribe_newsletter: boolean;
	public address: string;
	public email: string;
	public password: string;
	public country: string;
	public gender: string;
	public postal_code: string;
	public city: string;
	public last_name: string;
	public first_name: string;
	public phone_number: string;
	public phone_code: string;
	public cgos_agent_id: string = "";
	public window_location?: string;
	constructor(
		accept_conditions: boolean,
		subscribe_newsletter: boolean,
		address: string,
		email: string,
		password: string,
		country: string,
		gender: string,
		postal_code: string,
		city: string,
		last_name: string,
		first_name: string,
		phone_number: string,
		phone_code: string,
		cgos_agent_id = "",
		window_location?: string
	) {
		this.accept_conditions = accept_conditions;
		this.subscribe_newsletter = subscribe_newsletter;
		this.address = address;
		this.email = email;
		this.password = password;
		this.country = country;
		this.gender = gender;
		this.postal_code = postal_code;
		this.city = city;
		this.last_name = last_name;
		this.first_name = first_name;
		this.phone_number = phone_number;
		this.phone_code = phone_code;
		this.cgos_agent_id = cgos_agent_id;
		this.window_location = window_location;
	}
}
